var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      attrs: { title: "总监部门成员信息", width: 60 },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _vm.$globalSpin
        ? _c("Spin", { attrs: { size: "large", fix: "" } })
        : _vm._e(),
      _c(
        "Form",
        {
          ref: "modelForm",
          staticClass: "small-form",
          attrs: {
            model: _vm.modelForm,
            rules: _vm.ruleValidate,
            "label-position": "top",
          },
        },
        [
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c("FormItem", { attrs: { label: "说明" } }, [
                    _c("span", [
                      _vm._v(
                        "填写公司名称(新增公司或者新增公司与苗场的关联关系)：公司名称手动填写，部门下拉框会显示所有苗场，联动显示成员"
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "公司名称", prop: "projectCompany" } },
                    [
                      _c("Input", {
                        model: {
                          value: _vm.modelForm.projectCompany,
                          callback: function ($$v) {
                            _vm.$set(_vm.modelForm, "projectCompany", $$v)
                          },
                          expression: "modelForm.projectCompany",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "选择部门", prop: "seedFarmUuid" } },
                    [
                      _c(
                        "Select",
                        {
                          attrs: { filterable: "", clearable: "" },
                          on: { "on-change": _vm.onSeedFarmChange },
                          model: {
                            value: _vm.modelForm.seedFarmUuid,
                            callback: function ($$v) {
                              _vm.$set(_vm.modelForm, "seedFarmUuid", $$v)
                            },
                            expression: "modelForm.seedFarmUuid",
                          },
                        },
                        _vm._l(_vm.deptList, function (item) {
                          return _c("Option", {
                            key: item.seedFarmUuid,
                            attrs: {
                              value: item.seedFarmUuid,
                              label:
                                item.seedFarmCode + "~" + item.seedFarmName,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "选择成员", prop: "projectCode" } },
                    [
                      _c(
                        "Select",
                        {
                          attrs: { filterable: "", clearable: "" },
                          model: {
                            value: _vm.modelForm.projectCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.modelForm, "projectCode", $$v)
                            },
                            expression: "modelForm.projectCode",
                          },
                        },
                        _vm._l(_vm.memberList, function (item) {
                          return _c("Option", {
                            key: item.userName,
                            attrs: {
                              value: item.userName,
                              label: item.userPersonName,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "Button",
            { attrs: { type: "primary" }, on: { click: _vm.onSave } },
            [_vm._v("确认")]
          ),
          _c(
            "Button",
            { attrs: { type: "error" }, on: { click: _vm.onCancel } },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }